import { SxProps, Theme } from "@mui/material";

// Styles for the Chatbot component
const styles = {
  chatbotContainer: (theme: Theme): SxProps<Theme> => ({
    position: "fixed",
    bottom: 16,
    right: 16,
    width: "min(444px, 90vw)", // responsive: max 444px or 90% of screen
    height: "min(430px, 80vh)", // responsive: max 430px or 80% of screen
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[3],
    borderRadius: "8px",
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    zIndex: 1001,
    [theme.breakpoints.down("sm")]: {
      width: "90%",
      height: "70%",
      bottom: 50,
      right: "5%",
      borderRadius: "12px",
    },
  }),

  noHeaderContainer: {
    height: "351px",
    overflowY: "auto",
  },

  noHeaderInput: {
    mt: 2,
  },

  chatbotHeader: (theme: Theme): SxProps<Theme> => ({
    color: theme.palette.text.secondary,
    padding: "8px 16px",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
  }),

  chatbotBody: (theme: Theme): SxProps<Theme> => ({
    flex: 1,
    backgroundColor: theme.palette.background.default,
    overflowY: "auto",
    gap: 2,
  }),

  chatbotInputContainer: (theme: Theme): SxProps<Theme> => ({
    display: "flex",
    flexDirection: "column",
    padding: 2,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[3],
    position: "sticky",
  }),

  inputBox: {
    display: "flex",
    alignItems: "center",
    width: "100%",
    backgroundColor: "inherit",
    borderRadius: 2,
    padding: "4px 8px",
    border: "1px solid #CFD8DC",
  },

  inputBase: {
    flex: 1,
    fontSize: "14px",
  },

  sendButton: {
    width: "36px",
    height: "36px",
    "&:hover": {
      backgroundColor: "#d0d0d0",
    },
  },

  containerSpacing: {
    paddingLeft: "24px",
    paddingRight: "24px",
  },

  helperText: (theme: Theme): SxProps<Theme> => ({
    paddingLeft: "16px",
    color: theme.palette.text.secondary,
  }),

  messageBox: {
    display: "flex",
    flexDirection: "column",
    gap: 1.5,
    paddingTop: 1,
    paddingBottom: 1,
    paddingLeft: 2,
    paddingRight: 2,
    backgroundColor: "inherit",
    borderRadius: "12px",
    border: "1px solid #CFD8DC",
    mt: 1,
  },

  avatarIcon: {
    display: "flex",
    alignItems: "center",
    gap: 1,
  },

  messageAvatar: {
    bgcolor: "#4BA4B8",
    color: "white",
    width: "32px",
    height: "32px",
    fontSize: "16px",
  },

  messageUser: {
    color: "grey.800",
  },

  messageText: {
    color: "grey.900",
    lineHeight: 1.5,
  },

  answerBox: {
    backgroundColor: "#f5f5f5",
    marginTop: 2,
    marginBottom: 2,
    borderRadius: "12px",
    paddingTop: 1,
    paddingBottom: 1,
    paddingLeft: 2,
    paddingRight: 2,
  },

  messageAnswer: {
    marginTop: 1,
    wordWrap: "break-word",
    overflowWrap: "break-word",
  },

  messageHeader: {
    mt: 2,
  },

  messageSources: (theme: Theme): SxProps<Theme> => ({
    mt: 1,
    color: theme.palette.primary.main,
  }),

  actionContainer: {
    display: "flex",
    alignItems: "center",
    gap: 1,
    mt: 5,
    mb: 2,
  },

  actionButton: {
    paddingLeft: "24px",
    paddingRight: "24px",
  },

  actionIcon: {
    minWidth: "40px",
    padding: "4px",
    paddingTop: "6px",
    "&:hover": {
      borderColor: "grey.600",
      backgroundColor: "grey.100",
    },
  },

  expandableSection: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    cursor: "pointer",
    mt: 2,
  },

  modalContainer: {
    position: "absolute" as "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 368,
    backgroundColor: "white",
    borderRadius: "8px",
    boxShadow: 24,
    padding: 4,
    textAlign: "left",
  },

  modalHeader: {
    fontWeight: "bold",
    marginBottom: 2,
  },

  modalBody: {
    marginBottom: 3,
    color: "#4A4A4A",
  },

  modalActions: {
    display: "flex",
    justifyContent: "flex-end",
    gap: 1,
  },

  modalButton: {
    minWidth: "100px",
    fontWeight: "bold",
    textTransform: "uppercase",
  },

  emptyState: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
  },

  loaderContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    mt: 2,
    mb: 2,
  },

  moreButtonContainer: {
    p: 2,
    width: "100%",
    boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.25)", // Custom box shadow
    bgcolor: "background.paper",
  },

  textField: (theme: Theme): SxProps<Theme> => ({
    width: "100%", // Aligns with the container's width
    marginTop: "16px",
    marginBottom: "16px",
  }),
};

export default styles;
